// VAT Toggle for Header - Completely pauses during cart add/auto-open
(function() {
  const STORAGE_KEY = 'sofia-vat-display-mode';
  let toggleInjected = false;
  /** @type {ReturnType<typeof setTimeout> | null} */
  let reinjectTimeout = null;
  let isPaused = false; // Global pause flag
  /** @type {ReturnType<typeof setTimeout> | null} */
  let pauseTimeout = null;

  function getSavedMode() {
    /** @type {'incl' | 'excl' | null} */
    let mode = /** @type {any} */ (localStorage.getItem(STORAGE_KEY));
    if (mode !== 'incl' && mode !== 'excl') {
      mode = 'excl';
    }
    return mode;
  }

  function getHeaderSettings() {
    let header = document.getElementById('header-component');
    if (!header) header = document.querySelector('header-component');
    if (!header) header = document.querySelector('header');
    if (!header) header = document.querySelector('.header');
    
    if (!header) {
      return { enabled: true, fontSize: '0.9rem', activeColor: '#000000' };
    }
    
    const enabledAttr = header.getAttribute('data-vat-toggle-enabled');
    const enabled = enabledAttr === null ? true : enabledAttr === 'true';
    
    return {
      enabled: enabled,
      fontSize: header.getAttribute('data-vat-toggle-font-size') || '0.9rem',
      activeColor: header.getAttribute('data-vat-toggle-active-color') || '#000000'
    };
  }

  function syncGlobalActiveColor() {
    const settings = getHeaderSettings();
    if (settings && settings.activeColor) {
      document.documentElement.style.setProperty('--sofia-vat-toggle-active-color', settings.activeColor);
    }
  }

  function isDialogActive() {
    if (document.querySelector('dialog[open], dialog.dialog-closing')) return true;
    if (document.body.style.position === 'fixed') return true;
    if (document.documentElement.hasAttribute('scroll-lock')) return true;
    return false;
  }

  // Pause all activity (e.g., when cart is opening)
  function pauseActivity(duration = 2000) {
    isPaused = true;
    if (pauseTimeout) clearTimeout(pauseTimeout);
    pauseTimeout = setTimeout(function() {
      // Only unpause if dialog is actually closed
      if (!isDialogActive()) {
        isPaused = false;
      } else {
        // Still active, check again in 500ms
        pauseTimeout = setTimeout(function() {
          isPaused = false;
        }, 500);
      }
    }, duration);
  }

  /**
   * @param {'incl' | 'excl'} mode
   */
  function applyVatMode(mode) {
    const els = document.querySelectorAll('[data-vat-excl]');
    els.forEach((el) => {
      const excl = el.getAttribute('data-vat-excl');
      const incl = el.getAttribute('data-vat-incl');
      const fromLabel = el.getAttribute('data-vat-from-label');
      
      let priceToDisplay = '';
      if (mode === 'incl' && incl) {
        priceToDisplay = incl;
      } else if (excl) {
        priceToDisplay = excl;
      }
      
      if (fromLabel && priceToDisplay) {
        el.textContent = fromLabel + ' ' + priceToDisplay;
      } else if (priceToDisplay) {
        el.textContent = priceToDisplay;
      }
    });
  }

  /**
   * @param {'incl' | 'excl'} mode
   */
  function updateToggleUI(mode) {
    /** @type {NodeListOf<HTMLElement>} */
    const toggles = /** @type {any} */ (document.querySelectorAll('.header__vat-toggle'));
    const settings = getHeaderSettings();
    const activeColor = settings?.activeColor || '#000000';

    // Ensure non-header toggles (mobile/block) can use the same active color via CSS var
    syncGlobalActiveColor();
    
    toggles.forEach(toggle => {
      /** @type {NodeListOf<HTMLButtonElement>} */
      const buttons = /** @type {any} */ (toggle.querySelectorAll('[data-vat-mode]'));
      buttons.forEach((btn) => {
        const btnMode = btn.getAttribute('data-vat-mode');
        const isActive = btnMode === mode;
        
        btn.classList.toggle('vat-toggle__option--active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        
        if (isActive) {
          btn.style.background = activeColor;
          btn.style.color = '#fff';
          btn.style.borderColor = activeColor;
        } else {
          btn.style.background = 'transparent';
          btn.style.color = 'inherit';
          btn.style.borderColor = 'var(--color-border, #e6e6e6)';
        }
      });
    });
  }

  /**
   * @param {'incl' | 'excl'} initialMode
   * @param {{ enabled: boolean, fontSize: string, activeColor: string }} settings
   * @param {{ sticky?: boolean }} [opts]
   */
  function createToggleElement(initialMode, settings, { sticky = false } = {}) {
    const isIncl = initialMode === 'incl';
    const fontSize = settings?.fontSize || '0.9rem';
    const activeColor = settings?.activeColor || '#000000';
    
    const container = document.createElement('div');
    container.className = sticky
      ? 'header__vat-toggle header__vat-toggle--sticky vat-toggle mobile:hidden'
      : 'header__vat-toggle vat-toggle mobile:hidden';
    container.setAttribute('data-vat-toggle', '');
    container.style.cssText = 'display:inline-flex;align-items:center;gap:0.35rem;margin-right:0.75rem;font-size:' + fontSize + ';';
    
    const exclBtn = document.createElement('button');
    exclBtn.type = 'button';
    exclBtn.className = 'vat-toggle__option' + (isIncl ? '' : ' vat-toggle__option--active');
    exclBtn.setAttribute('data-vat-mode', 'excl');
    exclBtn.setAttribute('aria-pressed', isIncl ? 'false' : 'true');
    exclBtn.textContent = 'Excl. VAT';
    exclBtn.style.cssText = 'border-radius:999px;border:1px solid var(--color-border,#e6e6e6);padding:0.15rem 0.6rem;background:' + (isIncl ? 'transparent' : activeColor) + ';color:' + (isIncl ? 'inherit' : '#fff') + ';border-color:' + (isIncl ? 'var(--color-border,#e6e6e6)' : activeColor) + ';cursor:pointer;font:inherit;font-size:' + fontSize + ';line-height:1.2;transition:background-color 140ms ease,color 140ms ease;white-space:nowrap;';
    
    const inclBtn = document.createElement('button');
    inclBtn.type = 'button';
    inclBtn.className = 'vat-toggle__option' + (isIncl ? ' vat-toggle__option--active' : '');
    inclBtn.setAttribute('data-vat-mode', 'incl');
    inclBtn.setAttribute('aria-pressed', isIncl ? 'true' : 'false');
    inclBtn.textContent = 'Incl. VAT';
    inclBtn.style.cssText = 'border-radius:999px;border:1px solid var(--color-border,#e6e6e6);padding:0.15rem 0.6rem;background:' + (isIncl ? activeColor : 'transparent') + ';color:' + (isIncl ? '#fff' : 'inherit') + ';border-color:' + (isIncl ? activeColor : 'var(--color-border,#e6e6e6)') + ';cursor:pointer;font:inherit;font-size:' + fontSize + ';line-height:1.2;transition:background-color 140ms ease,color 140ms ease;white-space:nowrap;';
    
    container.appendChild(exclBtn);
    container.appendChild(inclBtn);
    
    return container;
  }

  /** @returns {{ target: HTMLElement | null, insertBefore: boolean }} */
  function findTopTarget() {
    const localizationEl = document.querySelector('.dropdown-localization');
    if (localizationEl instanceof HTMLElement) return { target: localizationEl, insertBefore: true };

    const topRow = document.querySelector('.header__row--top');
    let targetElement = null;
    if (topRow) {
      targetElement = topRow.querySelector('.header__column--right') || topRow.querySelector('.header__column--left');
    }
    if (!targetElement) {
      targetElement = document.querySelector('.header__column--right, .header__column--left');
    }
    return { target: targetElement instanceof HTMLElement ? targetElement : null, insertBefore: false };
  }

  /** @returns {{ target: HTMLElement | null, beforeEl: HTMLElement | null }} */
  function findStickyTarget() {
    const bottomRow = document.querySelector('.header__row--bottom');
    if (!bottomRow) return { target: null, beforeEl: null };

    const target =
      bottomRow.querySelector('.header__column--right') ||
      bottomRow.querySelector('.header__column--left') ||
      bottomRow.querySelector('.header__columns');

    if (!(target instanceof HTMLElement)) return { target: null, beforeEl: null };

    // Prefer inserting before sticky actions if present
    const beforeEl = target.querySelector('header-actions.header-actions--sticky');
    return { target, beforeEl: beforeEl instanceof HTMLElement ? beforeEl : null };
  }

  /**
   * @param {HTMLElement} toggleEl
   * @param {{ target: HTMLElement | null, insertBefore?: boolean, beforeEl?: HTMLElement | null }} placement
   */
  function insertToggle(toggleEl, { target, insertBefore = false, beforeEl = null } = { target: null }) {
    if (!toggleEl || !target) return false;

    // If already placed somewhere in header, and the target contains it, we're good
    if (target.contains(toggleEl)) return true;

    try {
      if (insertBefore && target.parentNode) {
        target.parentNode.insertBefore(toggleEl, target);
        return true;
      }

      if (beforeEl && beforeEl.parentNode === target) {
        target.insertBefore(toggleEl, beforeEl);
        return true;
      }

      target.insertBefore(toggleEl, target.firstChild);
      return true;
    } catch (e) {
      console.warn('VAT toggle insert failed:', e);
      return false;
    }
  }

  document.addEventListener('click', function(e) {
    const target = e.target;
    if (!target || !(target instanceof Element)) return;
    
    const button = target.closest('.header__vat-toggle .vat-toggle__option');
    if (!button) return;
    
    e.preventDefault();
    
    const newMode = button.getAttribute('data-vat-mode');
    if (newMode !== 'incl' && newMode !== 'excl') return;
    
    localStorage.setItem(STORAGE_KEY, newMode);
    updateToggleUI(newMode);
    applyVatMode(newMode);
    
    window.dispatchEvent(new CustomEvent('vat-mode-changed', { detail: { mode: newMode } }));
  });

  function injectToggle() {
    // Don't inject if paused or dialog is active
    if (isPaused || isDialogActive()) {
      return false;
    }

    const settings = getHeaderSettings();
    
    if (settings && settings.enabled === false) {
      return false;
    }

    const savedMode = getSavedMode();

    try {
      let topToggle = document.querySelector('.header__vat-toggle:not(.header__vat-toggle--sticky)');
      let stickyToggle = document.querySelector('.header__vat-toggle.header__vat-toggle--sticky');

      const topToggleEl = topToggle instanceof HTMLElement ? topToggle : null;
      const stickyToggleEl = stickyToggle instanceof HTMLElement ? stickyToggle : null;

      topToggle = topToggleEl || createToggleElement(savedMode, settings, { sticky: false });
      stickyToggle = stickyToggleEl || createToggleElement(savedMode, settings, { sticky: true });

      const topPlacement = findTopTarget();
      const stickyPlacement = findStickyTarget();

      const placedTop = insertToggle(/** @type {HTMLElement} */ (topToggle), topPlacement);
      const placedSticky = insertToggle(/** @type {HTMLElement} */ (stickyToggle), stickyPlacement);

      if (placedTop || placedSticky) {
        updateToggleUI(savedMode);
        applyVatMode(savedMode);
        return true;
      }

      return false;
    } catch (e) {
      console.warn('VAT toggle injection failed:', e);
      return false;
    }
  }

  function scheduleReinject() {
    // Don't reinject if paused
    if (isPaused || isDialogActive()) {
      return;
    }
    
    if (reinjectTimeout) {
      clearTimeout(reinjectTimeout);
    }
    
    reinjectTimeout = setTimeout(function() {
      if (!isPaused && !isDialogActive()) {
        const topExists = document.querySelector('.header__vat-toggle:not(.header__vat-toggle--sticky)');
        const stickyExists = document.querySelector('.header__vat-toggle.header__vat-toggle--sticky');
        if (!topExists || !stickyExists) {
          injectToggle();
        }
      }
    }, 200);
  }

  // Watch header for changes, but only reinject when safe
  function watchHeader() {
    const header = document.querySelector('header, .header, header-component');
    if (!header) return;
    
    const observer = new MutationObserver(function(mutations) {
      // CRITICAL: Skip everything if paused or dialog active
      if (isPaused || isDialogActive()) {
        return;
      }
      
      // Check if toggle(s) were removed
      const topToggle = document.querySelector('.header__vat-toggle:not(.header__vat-toggle--sticky)');
      const stickyToggle = document.querySelector('.header__vat-toggle.header__vat-toggle--sticky');
      if (!topToggle || !stickyToggle) {
        scheduleReinject();
      }
    });
    
    observer.observe(header, {
      childList: true,
      subtree: true
    });
  }

  // Listen for cart add events and pause
  function setupCartListeners() {
    // Listen for cart:update event (fires when item is added)
    document.addEventListener('cart:update', function() {
      pauseActivity(3000); // Pause for 3 seconds
    }, true);
    
    // Also watch for dialog opening
    const dialogObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const target = mutation.target;
          if (target instanceof HTMLDialogElement) {
            if (target.hasAttribute('open')) {
              pauseActivity(3000); // Pause when dialog opens
            }
          }
        }
      });
    });
    
    // Watch all dialogs
    document.querySelectorAll('dialog').forEach(function(dialog) {
      dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
    
    // Watch for new dialogs
    const bodyObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node instanceof HTMLDialogElement) {
            dialogObserver.observe(node, { attributes: true, attributeFilter: ['open'] });
          } else if (node instanceof Element) {
            node.querySelectorAll('dialog').forEach(function(dialog) {
              dialogObserver.observe(dialog, { attributes: true, attributeFilter: ['open'] });
            });
          }
        });
      });
    });
    
    bodyObserver.observe(document.body, { childList: true, subtree: true });
  }

  window.addEventListener('vat-mode-changed', function(e) {
    const ce = /** @type {CustomEvent<{ mode?: 'incl' | 'excl' }>} */ (/** @type {any} */ (e));
    if (ce.detail && ce.detail.mode) {
      updateToggleUI(ce.detail.mode);
      applyVatMode(ce.detail.mode);
    }
  });

  function start() {
    // Make the active color available globally for mobile/block toggles
    syncGlobalActiveColor();
    // Set up cart listeners first
    setupCartListeners();
    
    // Initial injection
    requestAnimationFrame(function() {
      requestAnimationFrame(function() {
        toggleInjected = injectToggle();
        
        // Set up watcher to reinject if removed
        watchHeader();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    setTimeout(start, 100);
  }
})();
